'use client';

import { type CouponHeaderCardData, CouponHeaderCardLayout } from './CouponHeaderCardLayout';
import { VisitorSecondaryButton } from './VisitorSecondaryButton';

interface VisitorCouponHeaderCardProps {
  data: CouponHeaderCardData;
  isReceiving?: boolean;
  onClickShop: () => void;
  onClickGuide: () => void;
  onReceive: () => void;
  className?: string;
}

export const VisitorCouponHeaderCard = ({
  data,
  isReceiving,
  onClickShop,
  onClickGuide,
  onReceive,
  className,
}: VisitorCouponHeaderCardProps) => (
  <CouponHeaderCardLayout
    data={data}
    showInfoIcon
    onClickShop={onClickShop}
    onClickGuide={onClickGuide}
    secondaryButton={
      <VisitorSecondaryButton status={data.status} disabled={isReceiving} onReceive={onReceive} />
    }
    className={className}
  />
);
